// extracted by mini-css-extract-plugin
export default {"container":"style_container__xLWI2","light":"style_light__o3X1Z","dark":"style_dark__e6X5W","link":"style_link__LEbjT","closeIcon":"style_closeIcon__Lpk1t"};